/**
 * Settings → Billing route — invoices + payment method (billing history).
 * The Subscription page (plan, usage, add-ons) lives at /settings/subscription.
 * @see apps/web/src/features/settings/billing/invoices-page.tsx
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { InvoicesPage } from "../../../../features/settings/billing/invoices-page.tsx";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/settings/billing/")({
  // URL-level `billing.manage` gate — see /settings/company/index.tsx for rationale.
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "billing.manage")) {
      throw notFound();
    }
  },
  component: InvoicesPage,
});
